var images = {
    APP_BACKGROUND: 'background-hero.jpg',
    APP_LOGO: 'oil-services-lab-logo.png',
    APP_LOGO_SMALL: 'oil-services-lab-logo-bug.png',
    TEST1: 'analytical-test1.jpg',
    TEST2: 'analytical-test2.jpg',
    TEST3: 'analytical-test3.jpg',
    TEST4: 'analytical-test4.jpg',
    SAMPLING_GUIDELINES1: 'sampling-guidelines1.jpg',
    SAMPLING_GUIDELINES2: 'sampling-guidelines2.jpg',
    SAMPLING_GUIDELINES3: 'sampling-guidelines3.jpg',
    SAMPLING_GUIDELINES4: 'sampling-guidelines4.jpg',
    CONTACT_IMAGE: 'contact-us.jpg',
    APPLE_STORE: 'apple-store.png'
}

export default images;



// WEBPACK FOOTER //
// ./web-app/constants/images.js